export default __webpack_public_path__ + "static/media/eatapp.c4587999.png";